const state = {
  // # Axios ###################
  // #################### Axios #

  // # Payment #################
  boosts: [],
  subscriptions: [],
  promotions: [],
  orders: [],
  paymentInformation: {},
  packages: [],
  stripeSubscriptions: [],
  stripeSubscriptionItems: [],
  // ################# Payment #

  stripeCustomer: {},
  stripePlans: [],
  stripeSubscriptionsHistory: [],
  stripeInvoicesHistory: [],

  freemium: null,


  serverAddress: import.meta.env.VITE_BACKEND_URL,

  loginStatusCode: null,
  registrationInProgress: false,
  // Set while the logout action runs so router guards cannot restore the session.
  logoutInProgress: false,
};

export default state;
